import { Alert, Box, Card, Heading, Paragraph, TextButton } from '@zillow/constellation-10';
import { useMainLayout } from '../../../layouts/MainPageLayout/MainLayoutContext';

const BuildingIllustration = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="108" height="108" viewBox="0 0 108 108" fill="none">
    <g clipPath="url(#clip0_7445_8964)">
      <path
        d="M23.7567 49.9839C35.4827 49.9429 29.264 0.662782 63.8227 0.0100499C98.3814 -0.642682 110.479 30.626 107.588 57.1068C104.698 83.5877 72.7556 108.124 43.7645 107.226C14.7723 106.329 -1.3922 81.4647 0.0942467 68.6427C1.58069 55.8197 8.95918 50.0356 23.7567 49.985V49.9839Z"
        fill="#FFF0E1"
      />
      <path
        d="M26.4338 83.5473C26.4338 83.5473 23.1737 81.6597 21.1151 82.689C19.0564 83.7183 19.3995 92.6403 19.3995 92.6403C19.3995 92.6403 17.5119 90.4095 15.1101 92.1251C12.7083 93.8407 14.938 99.6746 14.938 99.6746C14.938 99.6746 11.1638 99.3315 9.79021 101.219C8.41776 103.107 9.4471 107.739 9.4471 107.739H27.6342L26.4327 83.5462L26.4338 83.5473Z"
        fill="#136F65"
      />
      <path
        d="M79.2795 77.4725C79.2795 77.4725 81.8468 75.0268 84.1872 76.4815C86.5276 77.9351 85.5465 87.1212 85.5465 87.1212C85.5465 87.1212 89.472 86.0634 91.1327 87.4512C92.7935 88.839 91.0571 96.7031 91.0571 96.7031C91.0571 96.7031 97.0972 96.0421 98.3797 98.0909C99.6634 100.14 100.04 107.74 100.04 107.74H77.3918L79.2795 77.4714V77.4725Z"
        fill="#136F65"
      />
      <path d="M80.5699 23.7363H25.1821V80.5744H80.5699V23.7363Z" fill="#FFA385" />
      <path d="M80.5699 79.1445H25.1821V107.74H80.5699V79.1445Z" fill="#7D2103" />
      <path d="M52.1968 82.4336H40.2197V107.737H52.1968V82.4336Z" fill="#F08B00" />
      <path d="M64.9029 82.4404H52.9258V107.744H64.9029V82.4404Z" fill="#F08B00" />
      <path d="M50.6403 93.252H49.8115V98.9303H50.6403V93.252Z" fill="#D03C0B" />
      <path d="M55.1578 93.252H54.3291V98.9303H55.1578V93.252Z" fill="#D03C0B" />
      <path d="M40.5069 31.6582H34.1357V39.9784H40.5069V31.6582Z" fill="white" />
      <path d="M47.3079 31.6582H41.2722V39.9784H47.3079V31.6582Z" fill="white" />
      <path d="M47.3079 40.7773H41.2722V48.613H47.3079V40.7773Z" fill="white" />
      <path d="M40.5069 40.7773H34.1357V48.613H40.5069V40.7773Z" fill="white" />
      <path d="M48.4074 48.5654H33.3291V51.5186H48.4074V48.5654Z" fill="#D03C0B" />
      <path d="M40.8072 55.6201H34.436V63.9403H40.8072V55.6201Z" fill="white" />
      <path d="M47.607 55.6201H41.5713V63.9403H47.607V55.6201Z" fill="white" />
      <path d="M47.607 64.7393H41.5713V72.5749H47.607V64.7393Z" fill="white" />
      <path d="M40.8072 64.7393H34.436V72.5749H40.8072V64.7393Z" fill="white" />
      <path d="M48.7077 72.5254H33.6294V75.4786H48.7077V72.5254Z" fill="#D03C0B" />
      <path d="M64.2505 31.7324H57.8794V40.0526H64.2505V31.7324Z" fill="white" />
      <path d="M71.0503 31.7324H65.0146V40.0526H71.0503V31.7324Z" fill="white" />
      <path d="M71.0503 40.8535H65.0146V48.6892H71.0503V40.8535Z" fill="white" />
      <path d="M64.2505 40.8535H57.8794V48.6892H64.2505V40.8535Z" fill="white" />
      <path d="M72.152 48.6387H57.0737V51.5918H72.152V48.6387Z" fill="#D03C0B" />
      <path d="M64.5498 55.6943H58.1787V64.0145H64.5498V55.6943Z" fill="white" />
      <path d="M71.3518 55.6943H65.3162V64.0145H71.3518V55.6943Z" fill="white" />
      <path d="M71.3518 64.8145H65.3162V72.6501H71.3518V64.8145Z" fill="white" />
      <path d="M64.5498 64.8145H58.1787V72.6501H64.5498V64.8145Z" fill="white" />
      <path d="M72.4535 72.6006H57.3752V75.5538H72.4535V72.6006Z" fill="#D03C0B" />
      <path d="M80.6499 23.165H25.033V27.7439H80.6499V23.165Z" fill="#D03C0B" />
      <path
        d="M82.9804 17.25V18.344C82.9804 19.0368 82.6899 19.7044 82.1681 20.2119L81.7307 20.6395V21.1196C81.7307 21.933 81.4194 22.7211 80.8493 23.3515L80.629 23.5937H25.2259L25.0055 23.3515C24.4344 22.7211 24.1242 21.933 24.1242 21.1196V20.6395L23.6868 20.2119C23.165 19.7044 22.8745 19.0368 22.8745 18.344V17.25C22.9973 17.3618 82.8554 17.3618 82.9804 17.25Z"
        fill="#111116"
      />
      <path
        d="M80.7561 33.8585C89.5353 33.8585 96.6522 26.7416 96.6522 17.9624C96.6522 9.1833 89.5353 2.06641 80.7561 2.06641C71.977 2.06641 64.8601 9.1833 64.8601 17.9624C64.8601 26.7416 71.977 33.8585 80.7561 33.8585Z"
        fill="#0041D9"
      />
      <path
        d="M71.8035 19.9267L79.5448 27.2L89.9544 10.7098L86.8061 8.72461L78.9047 21.1972L74.5067 16.8858L71.8046 19.9278L71.8035 19.9267Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_7445_8964">
        <rect width="108" height="108" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const OverviewMapSidebarEmptyState = () => {
  const { selectedRegionId } = useMainLayout();

  return (
    <Box css={{ paddingInline: '600', paddingBlock: '400' }}>
      <Alert tone="info" css={{ marginBlockEnd: '400' }}>
        You don&apos;t have any properties in {selectedRegionId ? `this market` : `this area`}. Try setting your filters
        for a larger area.
      </Alert>

      <Card elevated={false}>
        <Box css={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
          <BuildingIllustration />

          <Heading level={5} css={{ marginBlockStart: '400', marginBlockEnd: '200' }}>
            Claim and list your properties for free
          </Heading>

          <Paragraph css={{ marginBlockEnd: '400' }}>
            Claiming your listings is quick, easy and free. Plus, it helps you bring your entire portfolio online and
            connect with renters on Zillow&apos;s all-in-one marketplace.
          </Paragraph>

          <TextButton textStyle="body-bold" asChild>
            <a
              href="https://www.zillow.com/rentals-network/claim-your-multifamily-listings/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Learn more
            </a>
          </TextButton>
        </Box>
      </Card>
    </Box>
  );
};
